module.exports = __webpack_public_path__ + "9b6d4f7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/download/slogan.png
// module id = 1278
// module chunks = 13